/**
 * clipFrameStore — Module-level store for video frames.
 *
 * Bridges the gap between ClipRenderer (which receives frames via onVideoFrame)
 * and ClipPlane (which needs the frame for Three.js texture capture).
 *
 * This eliminates DOM querying entirely — ClipRenderer pushes frames here,
 * ClipPlane reads them. The same codepath handles both preview and rendering
 * because onVideoFrame fires in both modes (with HTMLVideoElement in preview,
 * HTMLImageElement in rendering).
 */

export interface ClipFrame {
  source: CanvasImageSource
  width: number
  height: number
}

const frames = new Map<string, ClipFrame>()

export function setClipFrame(clipId: string, frame: ClipFrame) {
  frames.set(clipId, frame)
}

export function getClipFrame(clipId: string): ClipFrame | null {
  return frames.get(clipId) ?? null
}

export function clearClipFrame(clipId: string) {
  frames.delete(clipId)
}
